import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarNotificationComponent } from './components/ui/snackbar-notification/snackbar-notification.component';
import { NgModelChangeDebouncedDirective } from './directives/ng-model-change.directive';
import { OutSideClickDirective } from './directives/out-side-click.directive';
import { SocialShareComponent } from './dialog-view/social-share/social-share.component';
import { RefundNoteComponent } from './dialog-view/refund-note/refund-note.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatCardModule} from '@angular/material/card';
import {MaterialModule} from '../material/material.module';
import {NgxDropzoneModule} from 'ngx-dropzone';
import { CancelNoteComponent } from './dialog-view/cancel-note/cancel-note.component';

@NgModule({
  declarations: [
    SnackbarNotificationComponent,
    NgModelChangeDebouncedDirective,
    OutSideClickDirective,
    SocialShareComponent,
    RefundNoteComponent,
    CancelNoteComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxDropzoneModule,
  ],
  exports: [
    SnackbarNotificationComponent,
    NgModelChangeDebouncedDirective,
    OutSideClickDirective,
    SocialShareComponent
  ],
  providers: []
})
export class SharedModule {
}
